import { Map } from 'immutable';
import { ReduxAction } from 'types/redux.types';
import actions from './actions';

const roleTypes = {
  unauthorized: 'UNAUTHORIZED',
  restricted: 'RESTRICTED_ACCESS',
  view: 'VIEW_ACCESS',
  full: 'FULL_ACCESS',
};

const initState = Map<string, any>({
  role: roleTypes.unauthorized,
  roleLoading: true,
});

export default function candidateSearchReducer(state = initState, action: ReduxAction) {
  switch (action.type) {
    case actions.FETCH_CANDIDATE_SEARCH_ROLE_START:
      return state.set('roleLoading', true);
    case actions.FETCH_CANDIDATE_SEARCH_ROLE_DONE:
      return state.set('role', action.payload).set('roleLoading', false);
    case actions.FETCH_CANDIDATE_SEARCH_ROLE_CANCELLED:
      return state.set('role', roleTypes.unauthorized).set('roleLoading', false);
    case actions.FETCH_CANDIDATE_SEARCH_ROLE_ERROR:
      return state.set('role', roleTypes.unauthorized).set('roleLoading', false);
    case 'LOGOUT':
      return initState;
    default:
      return state;
  }
}

export { roleTypes };
